// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__-HQb4","wrap":"style_wrap__1Hxrh","close":"style_close__1gh6F"};